<template>
  <div class="condizioni-generali">
    <div class="default-container default-container-smaller">
        <h1 v-html="pageApiData.title"></h1>
        <p v-html="pageApiData.content"></p>
    </div>
  </div>
</template>

<script>
import lang from '@/views/mixins/lang'
import dataLoad from '@/views/mixins/dataLoad'

export default {
  mixins: [ lang, dataLoad ]
}
</script>
